module.exports = __webpack_public_path__ + "arrow-back.png?551b4b94514a1f353319b54158e66f8b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-back.png
// module id = 150
// module chunks = 0